import { useEffect, useRef, useState } from "react";
import { Power } from "lucide-react";

const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// variant: "restart" | "poweroff"; onComplete called for restart, onPowerOn shown for poweroff
export default function LinuxShutdownScreen({ variant = "poweroff", onComplete, onPowerOn }) {
  const messages = [
    "Stopping HMG Linux Lab services",
    "Stopping User Manager",
    "Stopping Network Manager",
    "Unmounting /home filesystem",
    variant === "restart" ? "Reached target Reboot" : "Reached target System Power Off",
  ];
  const [lines, setLines] = useState([]);
  const [off, setOff] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    let t = reduce ? 40 : 260;
    messages.forEach((m) => {
      t += reduce ? 40 : 180 + Math.random() * 200;
      timers.current.push(setTimeout(() => setLines((l) => [...l, m]), t));
    });
    timers.current.push(setTimeout(() => {
      if (variant === "restart") onComplete && onComplete();
      else setOff(true);
    }, t + 500));
    return () => timers.current.forEach(clearTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant]);

  if (off) {
    return (
      <div className="fixed inset-0 z-50 bg-black text-white flex flex-col items-center justify-center gdm-fade" data-testid="linux-powered-off">
        <div className="text-white/50 text-sm mb-6 font-mono">System powered off</div>
        <button
          data-testid="power-on-btn"
          onClick={() => onPowerOn && onPowerOn()}
          className="group flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-5 py-3 hover:border-[#38bdf8]/50 hover:bg-white/10 transition-colors"
        >
          <Power className="h-5 w-5 text-[#38bdf8]" />
          <span className="text-sm font-medium">Start HMG Linux Lab</span>
        </button>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black text-white flex items-center justify-center" data-testid="linux-shutdown-screen">
      <div className="w-full max-w-xl px-6 font-mono text-[13px] leading-6">
        {lines.map((m, i) => (
          <div key={i} className="flex gap-2"><span className="text-amber-400">[&nbsp;&nbsp;OK&nbsp;&nbsp;]</span><span className="text-white/70">{m}</span></div>
        ))}
      </div>
    </div>
  );
}
